<template>
  <el-dialog
    class="guarantee-dialog"
    :visible.sync="visible"
    width="51.5625vw"
    :before-close="cancel"
    center
  >
    <div class="main-title">保修信息</div>
    <ul class="guarantee-info">
      <li class="guarantee-info-item">
        <label>状态</label>
        <span>{{ getOverdue(formData.isOverdue) }}</span>
      </li>
      <li class="guarantee-info-item">
        <label>机型</label>
        <span>{{ formData.model }}</span>
      </li>
      <li class="guarantee-info-item">
        <label>IMEI/SN号</label>
        <span>{{ formData.IEMINumber }}</span>
      </li>
      <li class="guarantee-info-item has-addition">
        <label>预估保修截止日期</label>
        <span>{{ +formData.isEstimated ===1 ? '待更新' : formData.endTimeStr.slice(0, 10) }}</span>
      </li>

      <li class="guarantee-info-item" v-if="+formData.isEstimated === 1"><div class="label-tip"> (新购机用户正常使用3至5天后再查看) </div></li>
    </ul>

    <span slot="footer" class="guarantee-dialog-footer">
      <el-button class="submit-btn" @click="cancel">知道了</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
    }
  },
  methods: {
    cancel() {
      this.$emit('dialog-cancel');
    },
    getOverdue(overdue){
      if(overdue === 1){
        return "保修期内"
      }else if(overdue === 2){
        return "保修期外"
      }else if(overdue === 3){
        return "未激活"
      }
    }
  }
}
</script>

<style lang="scss">
.guarantee-dialog {
  .guarantee-info {
    width: 434px;
    margin: 0 auto;

    .guarantee-info-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 24px;

      &:last-child, &.has-addition {
        margin-bottom: 0;
      }

      .label-tip {
        size: 12px;
        color: #ffbb55;
      }

      label {
        font-size: 20px;
        font-family: OPPOSans-R, OPPOSans;
        font-weight: normal;
        color: #1f1f1f;
        line-height: 32px;
      }

      span {
        font-size: 20px;
        font-family: OPPOSans-R, OPPOSans;
        font-weight: normal;
        color: rgba(31, 31, 31, 0.6);
        line-height: 32px;
      }
    }
  }

  .main-title {
    height: 2.1875vw;
    margin-bottom: 40px;
    text-align: center;
    font-size: 1.666667vw;
    font-family: OPPOSans-M, OPPOSans;
    font-weight: normal;
    color: #191919;
    line-height: 2.1875vw;
  }

  .submit-btn {
    width: 160px;
    margin: 0 auto;
    padding: 0;
    line-height: 48px;
    color: #fff;
    font-size: 20px;
    text-align: center;
    background: #45c98e;
    border-radius: 4px;
    display: block;
  }
}
</style>